/**
 * Copyright (C) Siemens AG 1996-2026 ALL RIGHTS RESERVED.
 */

export interface AccessRequest {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  organization: string;
  purposeOfAccess: string;
  roles: string[];
  createdAt?: string;
  /** Current lifecycle status of the access request. */
  status?: AccessRequestStatus | string;
  /** Reason provided by the reviewer when declining the request. Only set when status is REJECTED. */
  rejectionReason?: string | null;
}

/** Allowed status values when updating an external access request. */
export enum AccessRequestStatus {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  CREATED = 'CREATED',
  VERIFIED = 'VERIFIED',
}

/** Lowercase status values used as query parameters for the list-access-requests API. */
export enum AccessRequestStatusQuery {
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  CREATED = 'created',
  VERIFIED = 'verified',
}

/** Query parameters supported by the list-access-requests endpoint. */
export interface AccessRequestListParams {
  offset?: number;
  limit?: number;
  status?: string;
}
